import React, { Component } from "react";

import { MOVEMENTS } from "../../config/const.js";
import { MERCHANDISER_MAIN_PAGE } from "../../config/lang";

import { translate } from "../..//util/util";
import { userDateJoined, userDateDeactivated, userDateTillNewbie } from "../../util/formatter";

class View extends Component {
  constructor(props) {
    super(props);
    this.state = { imgError: false };
  }

  render() {
    let { item, lang } = this.props;
    const isActive = item?.is_active;

    return (
      <div className="mp-view">
        <div className="mp-view-header">
          <div className="mp-view-avatar-wrap">
            {item?.photo && !this.state.imgError ? (
              <img
                src={item.photo}
                className="mp-view-avatar"
                onError={() => this.setState({ imgError: true })}
              />
            ) : (
              <div className="mp-view-avatar-fallback">
                <span className="material-symbols-outlined">person</span>
              </div>
            )}
            <span className={`mp-view-status-dot ${isActive ? "mp-view-status-dot--active" : "mp-view-status-dot--inactive"}`}></span>
          </div>
          <div className="mp-view-name-block">
            <h2 className="mp-view-name">{item && item.first_name + " " + item.last_name}</h2>
            <span className={`mp-view-status-chip ${isActive ? "mp-view-status-chip--active" : "mp-view-status-chip--inactive"}`}>
              {isActive ? "Active" : "Not Active"}
            </span>
          </div>
        </div>

        <div className="mp-view-grid">
          <div className="mp-view-info-card">
            <div className="mp-view-info-row">
              <span className="mp-view-info-label">
                <span className="material-symbols-outlined">phone</span>
                {translate(MERCHANDISER_MAIN_PAGE, "phone_number", lang)}
              </span>
              <span className="mp-view-info-value">{item?.phone_number || "—"}</span>
            </div>
            <div className="mp-view-info-row">
              <span className="mp-view-info-label">
                <span className="material-symbols-outlined">directions_walk</span>
                {translate(MERCHANDISER_MAIN_PAGE, "movement", lang)}
              </span>
              <span className="mp-view-info-value">
                <span className="mp-view-movement-chip">{item && MOVEMENTS[item.movement]}</span>
              </span>
            </div>
          </div>

          <div className="mp-view-info-card">
            <div className="mp-view-info-row">
              <span className="mp-view-info-label">
                <span className="material-symbols-outlined">calendar_today</span>
                {translate(MERCHANDISER_MAIN_PAGE, "connected", lang)}
              </span>
              <span className="mp-view-info-value">{item && userDateJoined("", item)}</span>
            </div>
            <div className="mp-view-info-row">
              <span className="mp-view-info-label">
                <span className="material-symbols-outlined">event_busy</span>
                {translate(MERCHANDISER_MAIN_PAGE, "deactivated", lang)}
              </span>
              <span className="mp-view-info-value">{item && userDateDeactivated("", item) || "—"}</span>
            </div>
            <div className="mp-view-info-row">
              <span className="mp-view-info-label">
                <span className="material-symbols-outlined">new_releases</span>
                {translate(MERCHANDISER_MAIN_PAGE, "till_newbie", lang)}
              </span>
              <span className="mp-view-info-value">{item && userDateTillNewbie("", item) || "—"}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default View;
